/* eslint-disable @typescript-eslint/ban-types */
import flat from 'flat'
import { updatedDiff } from 'deep-object-diff'

type Props = Parameters<typeof updatedDiff>

export const objectDiffByPath = (...props: Props): object => {
    const [leftObj, rightObj] = props
    const flatLeft: object = flat(leftObj)
    const flatRight: object = flat(rightObj)

    const diff = updatedDiff(flatLeft, flatRight)

    return diff
}
